import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";

import { Breadcrumb } from "../../models/Breadcrumb";

@Component({
  selector: "breadcrumbs",
  templateUrl: "./breadcrumbs.component.html",
  styleUrls: ["./breadcrumbs.component.scss"],
  imports: [RouterLink]
})
export class BreadcrumbsComponent implements OnInit {
  breadcrumbs: Array<Breadcrumb>;
  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.router.events.subscribe(() => {
      this.breadcrumbs = [];
      let currentRoute: ActivatedRoute = this.route.root;
      let url = "";
      do {
        const childrenRoutes = currentRoute.children;
        currentRoute = null;
        childrenRoutes.forEach((route) => {
          if (route.outlet === "primary") {
            if (route.snapshot.url.length > 0) {
              url +=
                "/" +
                route.snapshot.url
                  .map((segment) => segment.path)
                  .filter((p) => p)
                  .join("/");

              const label: string = route.snapshot.data["breadcrumbLabel"];

              if (label) {
                this.breadcrumbs.push({
                  Label: label,
                  URL: url
                });
              }
            }
            currentRoute = route;
          }
        });
      } while (currentRoute);
    });
  }
}
